import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
            showPackage: true,
            showContractHolder: false,
            showContractNumber: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        propertySubjects: {
            showSimplifiedAddress: false,
        },
        showLinkedLoans: true,
    },
    history: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
